import React, { useEffect, useState } from "react";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import custom_getvalue from "../../../components/main_comps/custom_getvalue";

const Container = ({ title, value }) => {
  return (
    <div style={{ display: "flex", marginBottom: "20px" }}>
      <p
        style={{
          color: "#000000",
          fontSize: "14px",
          fontWeight: "500",
          width: "180px",
        }}
      >
        {title}
      </p>
      <p style={{ color: "#3A3A3A", fontSize: "14px" }}>{value}</p>
    </div>
  );
};

const inputStyle = {
  backgroundColor: "#F3F3F3",
  alignSelf: "center",
  height: 40,
  boxShadow: "none",
  outline: "none",
  paddingLeft: 10,
  boxSizing: "border-box",
  borderRadius: "5px",
  width: "100%",
};
const containerStyle = {
  padding: 0,
  maxWidth: 300,
  minWidth: "250px",
  width: "100%",
  height: "40px",
};

const BankAccountDetails = ({ data, isEditClicked, onChange }) => {
  const [nameAsPerBank, setNameAsPerBank] = useState("");
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [bankIfscCode, setBankIfscCode] = useState("");

  useEffect(() => {
    onChange({
      nameAsPerBank: custom_getvalue(nameAsPerBank, data?.nameAsPerBank),
      bankAccountNumber: custom_getvalue(
        bankAccountNumber,
        data?.bankAccountNumber
      ),
      bankIfscCode: custom_getvalue(bankIfscCode, data?.bankIfscCode),
    });
  }, [nameAsPerBank, bankAccountNumber, bankIfscCode]);

  useEffect(() => {
    setNameAsPerBank(data?.nameAsPerBank);
    setBankAccountNumber(data?.bankAccountNumber);
    setBankIfscCode(data?.bankIfscCode);
  }, [isEditClicked]);

  return (
    <div style={{ padding: "10px 20px" }}>
      {isEditClicked ? (
        <>
          <div style={{ width: "50%", minWidth: "400px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Name:"}
              </p>
              <CustomInput
                value={nameAsPerBank}
                onChange={(data) => setNameAsPerBank(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Name as per Bank"
                validator={"businessName"}
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Bank account Number:"}
              </p>
              <CustomInput
                value={bankAccountNumber}
                onChange={(data) => setBankAccountNumber(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Bank Account Number"
                validator="accountNumber"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Bank IFSC code:"}
              </p>
              <CustomInput
                value={bankIfscCode}
                onChange={(data) => setBankIfscCode(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Bank IFSC code"
                validator="ifscCode"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
          </div>
        </>
      ) : (
        <div style={{ padding: "10px 20px" }}>
          <Container title="Name:" value={data?.nameAsPerBank} />
          <Container
            title="Bank account Number:"
            value={data?.bankAccountNumber}
          />
          <Container title="Bank IFSC code:" value={data?.bankIfscCode} />
        </div>
      )}
    </div>
  );
};

export default BankAccountDetails;
